<template>
  <b-modal
      :id="modalId"
      v-model="showModal"
      :title="title"
      size="lg"
      centered
      @hidden="onHidden"
  >
    <div v-if="loadingModal" class="d-flex justify-content-center my-3">
      <div class="spinner-border text-custom-blue">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <iframe
        v-else-if="htmlContent"
        title="Carteira de Vacinação"
        class="html-iframe"
        :srcdoc="htmlContent"
    ></iframe>

    <template #modal-footer>
      <b-button
          variant="primary"
          @click="$emit('download')"
          :disabled="loadingModal || loadingDownload || !htmlContent"
      >
        <feather-icon
            v-if="!loadingDownload"
            icon="DownloadIcon"
            size="16"
            class="mr-1"
        />
        <b-spinner
            v-else
            small
            variant="light"
            class="mr-1"
        />
        {{ loadingDownload ? 'Baixando...' : 'Baixar PDF' }}
      </b-button>
      <b-button
          variant="secondary"
          @click="closeModal"
      >
        Fechar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BButton, BSpinner} from "bootstrap-vue";

export default {
  name: "CarteiraVacinacaoModal",
  components: {
    BModal,
    BButton,
    BSpinner,
  },
  props: {
    modalId: {
      type: String,
      default: "modal-view-carteira"
    },
    title: {
      type: String,
      default: "Carteira de Vacinação"
    },
    show: {
      type: Boolean,
      default: false
    },
    loadingModal: {
      type: Boolean,
      default: false
    },
    loadingDownload: {
      type: Boolean,
      default: false
    },
    htmlContent: {
      type: String,
      default: null
    }
  },
  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    onHidden() {
      this.$emit('hidden');
    }
  }
};
</script>

<style scoped>
.html-iframe {
  width: 100%;
  height: 70vh;
  border: none;
}
</style>
